<div class="card" style="height: 100%; width: 100%; margin-right: 1%">
  <div class="card-body">
    <div
      class="insights-header-section pb-4 mb-4"
      style="border-bottom: 2px solid #e9ecef;"
    >
      <div class="d-flex justify-content-between align-items-center">
        <div class="d-flex align-items-center">
          <div class="header-icon-container me-3">
            <i class="bi bi-lightbulb"></i>
          </div>
          <div class="title-section">
            <h3 class="main-title mb-1">AI Insights & Recommendations</h3>
            <p class="subtitle text-muted mb-0">
              Powered by Aivor Intelligence
            </p>
          </div>
        </div>

        <div *ngIf="totalTokensConsumed !== null" class="token-counter-section">
          <div class="token-badge">
            <div class="token-icon">
              <i class="bi bi-cpu"></i>
            </div>
            <div class="token-info">
              <div class="token-label">AI Tokens left</div>
              <div class="token-count">
                {{ tokensRemaining | number }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="action-section mb-4">
      <button
        class="aivor-btn w-100 d-flex align-items-center justify-content-center gap-2"
        (click)="handleProcessPrompt()"
        [disabled]="
          IsLoading || (tokensRemaining !== null && tokensRemaining <= 0)
        "
      >
        <i class="bi bi-lightbulb" style="font-size: 18px"></i>
        <span>{{ IsLoading ? "Processing..." : "Ask Aivor" }}</span>
      </button>
    </div>

    <div
      *ngIf="IsLoading"
      class="loading-section d-flex flex-column justify-content-center align-items-center py-5"
    >
      <div class="spinner-border aivor-spinner mb-3" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
      <p class="loading-text text-muted">Generating AI insights...</p>
    </div>

    <div
      *ngIf="!IsLoading && recommendations.length > 0"
      class="insights-container fade-in"
    >
      <div class="insights-content-header mb-3">
        <div class="d-flex align-items-center gap-2 mb-2">
          <i class="bi bi-stars content-icon"></i>
          <h5 class="m-0 content-title">Key Recommendations</h5>
        </div>
        <p class="content-subtitle text-muted mb-0">
          AI-generated insights to optimize your business performance
        </p>
      </div>

      <div class="recommendations-list scrollable-container">
        <div
          *ngFor="let recommendationGroup of recommendations; let i = index"
          class="mb-4"
        >
          <div
            *ngFor="let sentence of recommendationGroup; let j = index"
            class="insight-card-container mb-2"
          >
            <div
              class="insight-card"
              [ngClass]="{
                'primary-insight': j === 0,
                'secondary-insight': j > 0
              }"
            >
              <div class="insight-content">
                <div class="insight-text">{{ sentence }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      *ngIf="!IsLoading && recommendations.length === 0"
      class="empty-state text-center py-4"
    >
      <div class="empty-icon mb-3">
        <i
          class="bi bi-lightbulb text-muted"
          style="font-size: 3rem; opacity: 0.3"
        ></i>
      </div>
      <p class="text-muted">
        Click "Ask Aivor" to generate AI-powered insights for your business
      </p>
    </div>
  </div>
</div>
